<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.5542 6.28564H1.44567C0.92489 6.28564 0.502808 6.70773 0.502808 7.22851V21.0571C0.502808 21.5779 0.92489 22 1.44567 22H20.5543C21.075 22 21.4971 21.5779 21.4971 21.0571V7.22851C21.4971 6.70773 21.075 6.28564 20.5542 6.28564ZM19.6114 20.1142H2.38853V8.17133H19.6114V20.1142H19.6114Z"  class="icon-fill"/>
    <path d="M18.9828 3.14282H3.01708C2.4963 3.14282 2.07422 3.5649 2.07422 4.08569C2.07422 4.60647 2.4963 5.02855 3.01708 5.02855H18.9828C19.5036 5.02855 19.9257 4.60647 19.9257 4.08569C19.9257 3.5649 19.5036 3.14282 18.9828 3.14282Z"  class="icon-fill"/>
    <path d="M17.4114 0H4.58862C4.06783 0 3.64575 0.422082 3.64575 0.942863C3.64575 1.46364 4.06783 1.88573 4.58862 1.88573H17.4115C17.9323 1.88573 18.3543 1.46364 18.3543 0.942863C18.3543 0.422082 17.9322 0 17.4114 0Z"  class="icon-fill"/>
  </svg>

</template>

<script>
export default {
  name: 'slideshow'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>